import agent from './agent';
import {
  ASYNC_START,
  ASYNC_END,
  LOGIN,
  LOGOUT
} from './constants/actionTypes';

const promiseMiddleware = store => next => action => {
  if (isPromise(action.payload)) {
    store.dispatch({ type: ASYNC_START, subtype: action.type });

    action.payload.then(
      res => {
        action.payload = res;
        store.dispatch({ type: ASYNC_END, promise: action.payload });
        store.dispatch(action);
      },
      error => {
        action.error = true;

        if(error.status === 401 || error.status === 403) {
          window.localStorage.setItem('jwt', '');
          window.localStorage.setItem('configurationId', '');
          agent.setToken(null);
          window.location.replace("#/login")
        }

        if(error.response && error.response.body) {
          action.payload = error.response.body;
        } else {
          action.payload = {"error":"Unknown error occurred contacting server"}
        }

        store.dispatch({ type: ASYNC_END, promise: action.payload });
        store.dispatch(action);
      }
    );

    return;
  }

  next(action);
};

const localStorageMiddleware = store => next => action => {

  if (action.type === LOGIN) {
    if (!action.error && action.payload.token && action.payload.token !== "" && action.payload.token !== "undefined") {
      window.localStorage.setItem('jwt', action.payload.token);
      window.localStorage.setItem('configurationId', action.payload.configurationId);
      agent.setToken(action.payload.token);
    }
  } else if (action.type === LOGOUT) {
    window.localStorage.setItem('jwt', '');
    window.localStorage.setItem('configurationId', '');
    agent.setToken(null);
  }

  next(action);
};

function isPromise(v) {
  return v && typeof v.then === 'function';
}


export { promiseMiddleware, localStorageMiddleware}



// WEBPACK FOOTER //
// ./src/middleware.js